import styled from "@emotion/styled";
import { BrushWrapper, Container, LoadingSpinner, Stack } from "atoms";
import { useHomePageData, tagList } from "features/hub/api/useHomePageData";
import { HomeTagListBlock } from "features/hub/components/HomeTagListBlock";
import { HomeHeroBlock } from "features/hub/components/HomeHeroBlock";
import { HomeCtaBlocks } from "features/hub/components/HomeCtaBlocks";
import { FeaturedProfileBlock } from "features/hub/components/FeaturedProfileBlock";
import { useAuth } from "features/auth";
import { FeaturedTagBlock } from "features/hub/components/FeaturedTagBlock";
import { MediumTagsBlock } from "features/hub/components/MediumTagsBlock";
import { HighlightBlock } from "features/hub/components/HighlightBlock";
import { useSearchParams } from "react-router-dom";
import { HomeAboutHUG } from "features/hub/components/HomeAboutHUG";
import { HomeReviews } from "features/hub/components/HomeReviews";
import { HomePageFeed } from "features/posts";

function HubHome() {
  const { user, roles } = useAuth();
  const [searchParams] = useSearchParams();
  const version = searchParams.get("version") ?? undefined;
  const { data, error, isLoading } = useHomePageData(version);

  if (data) {
    return (
      <>
        <HomeTagListBlock tags={tagList} />

        <HomeHeroBlock isSignedIn={!!user} items={data.heroBlock} />

        <HomeSection>
          <Container width="lg">
            <HomePageFeed />
          </Container>
        </HomeSection>

        {false && (
          <HomeSection>
            <Container width="lg">
              {/* === #3 Dynamic CTA Block === */}
              <HomeCtaBlocks user={user} roles={roles} />
            </Container>
          </HomeSection>
        )}

        <HomeSection>
          <Container width="lg">
            {/* Anchor destination for hero button  */}
            <ScrollAnchor id="explore">&nbsp;</ScrollAnchor>

            {/* === #5 Discover Tag Block === */}
            <FeaturedTagBlock {...data.discoverTagBlock} />
          </Container>
        </HomeSection>

        <BrushWrapper bg="bg" brush="3">
          <HomeSection>
            <Container width="lg">
              {/* === #4 Featured Artist Block === */}
              <FeaturedProfileBlock
                {...data.featuredArtistBlock}
                id="explore"
              />
            </Container>
          </HomeSection>
        </BrushWrapper>

        <BrushWrapper bg="black" brush="2" css={{ zIndex: "2" }}>
          <HomeSection>
            <Container width="lg">
              {/* === #6 Art Medium Categories Block === */}
              <MediumTagsBlock />
            </Container>
          </HomeSection>
        </BrushWrapper>

        <HomeSection>
          <Container width="lg">
            {/* === #7 & #8 "Highlight Block" === */}
            <HighlightBlock
              entities={data.newestArtists}
              heading="New Artists"
              subheading="New Artists on&nbsp;HUG"
              cta="View Newest Artists"
              url="/search/?type=artist&sort=createdAt+desc"
              color={0}
            />
          </Container>

          {/* === #8 Flexible Highlight Block(s) === */}

          {/* Dynamic Block for repeater content */}
          {/*
            {data.highlightBlocks.map((highlightBlock, index) =>
              <HighlightBlock
                {...highlightBlock}
                key={highlightBlock.heading}
                index={index}
              />
            )}
             */}

          <Container width="lg">
            {/* Static block for launch */}
            <HighlightBlock
              {...data.highlightBlocks[0]}
              key={data.highlightBlocks[0].heading}
              // index={index}
              reverse
            />
          </Container>
        </HomeSection>

        <HomeSection css={{ zIndex: "2" }}>
          <Container width="lg">
            {/* === #9a Recent Review Block === */}
            {/* === #9b Top Reviewers Block === */}
            <HomeReviews
              newestReviews={data.newestReviews}
              topReviewersForMonth={data.topReviewersForMonth}
            />
          </Container>
        </HomeSection>

        <BrushWrapper bg="black" brush="2">
          <HomeSection>
            <Container width="lg">
              {/* === About HUG Block === */}
              <HomeAboutHUG />
            </Container>
          </HomeSection>
        </BrushWrapper>
      </>
    );
  }

  // TODO: lots of options on how to handle this
  // 1. return loading placeholder component with similar layout style (like ReviewableTemplate)
  // 2. better performance, but more work? hook could return initial/placeholder data and each
  //    component could handle it's own loading state, therefor hardcoded things could be shown
  //    immediately and could rely on lazy loading
  if (isLoading) {
    return <LoadingSpinner />;
  }

  // TODO: similar to above
  if (error) {
    return (
      <div>{error instanceof Error ? error.message : "Unknown error"}</div>
    );
  }

  return null;
}

const HomeSection = styled(Stack)(({ theme }) => ({
  overflowX: "clip",
  overflowY: "visible",
  paddingBottom: theme.spacing.xl,
  paddingTop: theme.spacing.xl,
  position: "relative",
}));
HomeSection.defaultProps = {
  gap: "lg",
};

const ScrollAnchor = styled.div({
  height: 0,
  marginTop: "0 !important",
});

export default HubHome;
